// Every timing and capacity number the board runs on, in one place: they are judged
// on the actual LG panel standing at the counter (build-guide §5, §8) and changing
// one must never mean hunting through components.

/** One hero slide is on screen this long, fade included (build-guide §5). */
export const DWELL_HERO_MS = 8000

/** Hero crossfade duration. */
export const FADE_MS = 1200

/** A list above its capacity turns the page this often. */
export const DWELL_PAGE_MS = 12000

/** Page fade when a paged list turns. */
export const PAGE_FADE_MS = 400

/** Catalog poll interval — a sold-out mark reaches the wall within this (owner 2026-09-15: 60 s). */
export const POLL_MS = 60000

/** Rows that fit the 984 px vertical budget; above this the list pages. */
export const CAPACITY = { main: 7, extras: 6 }

/** Screen 2 runs half a slide behind screen 1 so the two walls never flip together. */
export const SCREEN_OFFSET_MS = 4000

/** Local time of the nightly reload (the TV's on-timer bounds any slow leak). */
export const RELOAD_AT = '05:00'

/** The programs' time windows are read in this zone, not in the browser's. */
export const TIME_ZONE = 'Europe/Amsterdam'

/**
 * The category the Meal Deal hangs off: its first active variant is the id the
 * bundle lookup needs, and its screen is the one that gets the Meal Deal slide
 * (API contract: "plus the Meal Deal on the curry screen").
 */
export const CURRY_CATEGORY = 'Curries'

/**
 * The drinks column is the one list that compresses by price (contract: "group by
 * (price_cents, deposit_cents)"). Every other column lists its products as rows.
 */
export const DRINKS_CATEGORY = 'Drinks'
